import * as React from 'react';
import * as styles from './RightAdornment.css';

export interface IRightAdornmentProps {
  roadButton: {
    label: string;
    available: boolean;
  };
  onRegionClick(): void;
  onRoadClick(): void;
}

export const RightAdornment: React.FC<IRightAdornmentProps> = ({ roadButton, onRegionClick, onRoadClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['item']}>
        <button aria-label="Регион" className={styles['button']} onClick={onRegionClick}>
          Регион
        </button>
      </div>
      {roadButton.available && (
        <div className={styles['item']}>
          <button aria-label={roadButton.label} className={styles['button']} onClick={onRoadClick}>
            {roadButton.label}
          </button>
        </div>
      )}
    </div>
  );
};
